module.exports = __webpack_public_path__ + "static/media/price-tags4.47bd02e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/price-tags4.svg
// module id = 3385
// module chunks = 7